/* eslint-disable spire/export-styles */
import Zone from "@insite/client-framework/Components/Zone";
import { ColumnAlignment } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import * as React from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {
}

const styles = {
    wrapper: {
        css: css`
        display: flex;
        padding-top: 0;
        > div {
            display: flex;
            justify-content: space-between;
            max-width: 410px;
        }`,
    }
}

const Row: React.FunctionComponent<Props> = (props: Props) => {
    const {
        id,
    } = props;

    return (
        <GridContainer>
            <GridItem width={12} {...styles.wrapper}>
                <Zone contentId={id} zoneName={`Content`} />
            </GridItem>
        </GridContainer>)
};

const widgetModule: WidgetModule = {
    component: Row,
    definition: {
        group: "Basic",
        icon: "Row",
        displayName: "RowInlineWidget",
        fieldDefinitions: [
        ],
    },
};

export default widgetModule;
